export default __webpack_public_path__ + "static/media/SeminarioIes2026_BibianaDavo.280eddb4.jpg";